import Handler from "./handler";
import http from "../../../http";
import { getQuery, sliceObject } from "../xes-lib";
import bindAll from "lodash.bindall";

class CommunityHandler extends Handler {
  constructor() {
    super()
    bindAll(this, [
      "save",
      "publish",
      "share"
    ])
  }
  init(state, dispatch) {
  }
  getProjectData() {
    let id = getQuery("pid",window.defaultPid)
    return http.getProjectById(id)
  }
  save(projectMeta) {
    return this.handleLockMethod(() => {
      let params = sliceObject([
        "thumbnail",
        "version",
        "name",
        "id",
        "xml",
        "original_id"
      ], projectMeta)
      return new Promise((resolve,reject)=>{
        http.saveProject(params)
        .then(data=>{
          // 标记保存成功，判断改编作品时使用
          data._adapt = true
          resolve(data)
        })
        .catch(err=>{
          reject(err)
          console.log(err)
        })
      })
    })
  }
  publish(projectMeta) {
    if (!projectMeta.id) return Promise.resolve()
    return this.handleLockMethod(() => {
      let description = document.getElementById('xes-desc').value
      let params = {
          description,
          name: projectMeta.projectTitle,
          projectId: projectMeta.id 
      }
      return http.publishProject(params)
    })
  }
  share(projectMeta) {
    return this.save(projectMeta)
  }
  createNew() {
    window.location.replace('https://code.xueersi.com/scratchmb/?env=community&pid=6')
  }
  static getInstance() {
    if (CommunityHandler.instance === null) {
      CommunityHandler.instance = new CommunityHandler()
    }
    return CommunityHandler.instance
  }
}
CommunityHandler.instance = null

export default CommunityHandler